<div *ngIf="form" [formGroup]="form" class="contact-section-cont">
  <div class="title">
    <app-ds-typography
      [tag]="'h3'"
      [size]="fontSize.XS"
      [color]="fontColor.Primary"
      [fontFamily]="fontFamily.SemiBold"
      [text]="title | transloco">
    </app-ds-typography>
  </div>
  <div class="description">
    <app-ds-typography
      [tag]="'p'"
      [size]="fontSize.XXS"
      [color]="fontColor.Secondary"
      [fontFamily]="fontFamily.Regular"
      [text]="description | transloco">
    </app-ds-typography>
  </div>
  <div class="body-cont">
    <app-ds-data-action-card
      [style]="dataActionCardStyle.Secondary"
      [info]="[
        withoutPhoneInfo && {
          Type: dataActionCardInfoType.Data,
          Title: phone,
          DataIcon: icons.Phone,
          ActionIcon: icons.ChevronRight
        },
        {
          Type: dataActionCardInfoType.Data,
          Title: email,
          DataIcon: icons.Email,
          ActionIcon: icons.ChevronRight
        }
      ]"
      (clickEvent)="open()">
    </app-ds-data-action-card>
  </div>
  <ng-container *ngIf="errorInContacts">
    <div class="only-error error">
      <span class="only-error">
        {{ errorMessage | transloco }}
      </span>
    </div>
  </ng-container>
</div>

<ng-container *ngIf="isMobile; else desktopModal">
  <app-swipe-up
    [height]="95"
    [showSwipeUp]="showContactInfo"
    [showHeader]="true"
    [title]="'BOOKING_MODULE.CONTACT_INFO.CONTACT_TITLE' | transloco"
    (toggleShowSwipeUp)="close()">
    <ng-container content>
      <ng-container *ngIf="showContactInfo">
        <ng-container *ngTemplateOutlet="contactForm"></ng-container>
      </ng-container>
    </ng-container>
  </app-swipe-up>
</ng-container>

<ng-template #desktopModal>
  <ng-container *ngIf="showContactInfoModal">
    <app-modal
      [width]="640"
      [showHeader]="true"
      [title]="'BOOKING_MODULE.CONTACT_INFO.CONTACT_TITLE' | transloco"
      (toggleModal)="close()">
      <ng-container content>
        <ng-container *ngTemplateOutlet="contactForm"></ng-container>
      </ng-container>
    </app-modal>
  </ng-container>
</ng-template>

<ng-template #contactForm>
  <div class="content-container">
    <p class="description">{{ formDescription | transloco }}</p>
    <div class="body">
      <app-contact-info
        [email]="email"
        [phone]="phone"
        [isSubmitted]="isSubmitted"
        [emailControl]="emailControl"
        [phoneControl]="phoneControl"
        [withoutPhoneInfo]="!!withoutPhoneInfo"
        (saveContactInfo)="saveContactInfo($event)">
      </app-contact-info>
    </div>
  </div>
</ng-template>
